<template>
    <div>
        <h6>Véhicules hors Argos</h6>

        <!-- PENDING : édition -->
        <template v-if="isEdit">
            <ul class="list-group mb-2">
                <li v-for="plate in (mission.missionPlates || [])" :key="plate.id"
                    class="list-group-item d-flex justify-content-between align-items-center">
                    {{ plate.plate }}
                    <button @click="$emit('removePlate', plate.id)"
                        class="btn btn-sm btn-outline-danger">
                        Supprimer
                    </button>
                </li>
            </ul>
            <div class="input-group">
                <input v-model="newPlate" type="text" class="form-control" placeholder="Exemple : AA-123-AA"
                    name="mission-plate" autocomplete="off" autocorrect="off" autocapitalize="none"
                    spellcheck="false" />
                <button class="btn btn-outline-primary" @click="emitAdd">Ajouter</button>
            </div>
        </template>

        <!-- ONGOING / FINISHED : lecture seule -->
        <template v-else>
            <div class="mb-2">
                <span v-if="mission?.missionPlates?.length" style="white-space: pre-line">
                    {{(mission.missionPlates || []).map(p => p.plate).join('\n ')}}
                </span>
                <span v-else class="text-muted">Aucun véhicule hors Argos</span>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: 'MissionPlateSection',
     props: {
        mission: { type: Object, required: true },
        /**
         * 'auto'  : comportement historique (édition si PENDING/DRAFT && !viewer)
         * 'edit'  : force l'édition
         * 'view'  : force la lecture seule
         */
        uiMode: {
            type: String,
            default: 'auto',
            validator: v => ['auto', 'edit', 'view'].includes(v)
        }
     },
    emits: ['addPlate', 'removePlate'],
    data() {
        return { newPlate: '' };
    },
    computed: {
        isEdit() {
            if (this.uiMode === 'edit') return true;
            if (this.uiMode === 'view') return false;
            // mode 'auto' : logique existante
            return (this.mission?.status === 'PENDING' || this.mission?.status === 'DRAFT' || this.mission?.status === 'ONGOING') && !this.$isViewer;
        }
    },
    methods: {
        emitAdd() {
            const v = (this.newPlate || '').trim();
            if (!v) return;
            this.$emit('addPlate', v);
            this.newPlate = '';
        }
    }
}
</script>
